module.exports = __webpack_public_path__ + "img/doi-example.bf3d7f84.png";